import { BlockContainer } from '@/components/Blocks';
import Box from '@/components/ui/Box';
import Flex from '@/components/ui/Flex';
import Grid from '@/components/ui/Grid';
import Txt from '@/components/ui/Txt';
import { createBlock } from '@/lib/parsers/blocks';
import * as styles from './QuickNavBlock.css';
import QuickNavButton from './QuickNavButton';

const QuickNavBlock = createBlock<'blocks_quickNav_BlockType'>(
  ({ _blockMeta: meta, content, linkFieldMultiple = [] }) => {
    return (
      <BlockContainer
        {...{
          meta,
          marginY: true,
          disableTransition: true,
        }}>
        <Grid>
          <Grid.Col offsetMd={2} md={8}>
            <Box className={styles.box}>
              {content && <Txt html>{content}</Txt>}
              {!!linkFieldMultiple?.length && (
                <Flex
                  wrap="wrap"
                  alignItems="start"
                  spacing="md"
                  direction={{ sm: 'column', md: 'row' }}
                  cx={{ mT: 'sm' }}>
                  {linkFieldMultiple?.map((item, i) => {
                    return <QuickNavButton key={i} {...item} />;
                  })}
                </Flex>
              )}
            </Box>
          </Grid.Col>
        </Grid>
      </BlockContainer>
    );
  }
);

export default QuickNavBlock;
